<template>
  <div class="wrapper-content border-radius border-gray-solid">
    <div class="options d-flex d-flex-just-beteween" style="align-items:center">
      <h5>Projetos por Status</h5>
      <div class="wrapper-status">
        <Select2
        v-model="ProjetoStatusAno"
        :options="Anos"
        :settings="{  }"
        @select="ProjetoStatusAnoSelect($event)"
      />
      </div>
    </div>
    <Loader v-if="!ProjetoStatusCarregado" />  
    <pie-chart
        :data="ProjetoStatus"
        v-if="ProjetoStatusCarregado && ProjetoStatus.datasets[0].data.length > 0"
        chart-id="bar-ProjetoStatusCarregado"
      ></pie-chart>
      <div class="text-center" v-else-if="ProjetoStatusCarregado">
        <h4>Sem Dados Para Exibição</h4>
      </div>
  </div>
</template>

<script>
import PieChart from "../Components/PieChart.vue";
import axios from "axios";
import Select2 from "v-select2-component";
export default {
  name: "ProjetoStatus",
  props: ["Anos", "Meses"],
  components: {
    PieChart,
    Select2
  },
  data() {
    return {
      ProjetoStatus: null,
      ProjetoStatusCarregado: false,
      ProjetoStatusAno: 2019
    };
  },
  mounted() {
    this.fillPorStatus();
  },
  methods: {
    ProjetoStatusAnoSelect: function(val) {
      this.ProjetoStatusAno = val.id;
      this.fillPorStatus();
    },
    fillPorStatus: function() {
      let self = this;
      self.ProjetoStatusCarregado = false;
      axios
        .get(
          this.$apiUrl +
            `Projeto.svc/dashboard/gestaoaldo/ProjetoStatus?ano=${self.ProjetoStatusAno}`
        )
        .then(function(response) {
          self.ProjetoStatus = {
            labels: response.data.labels,
            datasets: [
              {
                backgroundColor: "#707070",
                data: response.data.Qtde,
                backgroundColor: [
                  "rgb(175,238,238)",
                  "rgb(250,250,210)",
                  "rgb(135,206,235)",
                  "rgb(152,251,152)",
                  "rgb(176,224,230)",
                  "rgb(238,232,170",
                  "rgb(230,230,250)"
                ]
              }
            ]
          };
          self.ProjetoStatusCarregado = true;
          console.log("terminou de carregar os dados");
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>